import { useConfigContext } from 'contexts/config';

const useUnquantizeAmount = () => {
  const { ethQuantum } = useConfigContext();

  return (amount: bigint) => amount * ethQuantum;
};

export default useUnquantizeAmount;
